import { Injectable } from '@angular/core';
import { Benefits, ValuationBenefit } from '../models/benefts.interface';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BenefitsService {
  constructor(private httpClient: HttpClient) {}

  async getBenefits(): Promise<Benefits[]> {
    return firstValueFrom<Benefits[]>(
      this.httpClient.get<Benefits[]>(enviroment.url + 'benefitdos'),
    );
  }

  async getSubsidiaries(): Promise<any[]> {
    return firstValueFrom<any[]>(
      this.httpClient.get<any[]>(enviroment.url + 'beneficio/filiales'),
    );
  }

  async getValuationsBenefit(benefit_id: number): Promise<ValuationBenefit> {
    return firstValueFrom<ValuationBenefit>(
      this.httpClient.get<ValuationBenefit>(enviroment.url + `valoracion/${benefit_id}/detalle`),
    );
  }

  async putBenefits(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.put<any>(enviroment.url + 'benefit', element),
    );
  }

  async postBenefits(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'benefit', element),
    );
  }
  
  async getBenefitsGeneral(): Promise<Benefits[]> {
    return firstValueFrom<Benefits[]>(
      this.httpClient.get<Benefits[]>(enviroment.url + 'beneficios/general'),
    );
  }

  async putBenefithidden(body:any):Promise<any>{
    return firstValueFrom<any>(this.httpClient.put<any>(enviroment.url + "benefit_hidden", body),
  );
  }

  async put_segundo_aprobador(body:any):Promise<any>{
    return firstValueFrom<any>(this.httpClient.put<any>(enviroment.url + "segundo_aprobador", body),
  );
  }

  async setAndPostBenefit(body:any):Promise<any>{
    return firstValueFrom<any>(this.httpClient.post<any>(enviroment.url + "set_benefit", body),
  );
  }
  

}
